export const whatsappRegex = /^\d{2}9\d{8}$/;
